import { apiAuth, apiResponseType } from ".";

/** Aba "Premiações Totais" (Concursos > Premiações Totais) */

export interface TotalPrizesParams {
  date_start?: string;
  date_end?: string;
  lottery_id?: string[];
  contest_names?: string;
  page?: number;
  per_page?: number;
}

export type TotalPrizeInvestigationStatus = "complete" | "partial";

export interface TotalPrizeContest {
  contest_id: number;
  contest_uuid: string;
  contest_name: string;
  validation_date: string | null;
  is_active: boolean;
  lottery_id: number;
  lottery_name: string;
  lottery_color: string | null;
  investigation_status: TotalPrizeInvestigationStatus;
  total_products: number;
  investigated_products: number;
}

export interface TotalPrizeRow extends TotalPrizeContest {
  prize_total: number;
  prize_per_quota_total: number;
  awarded_tickets: number;
  cashier_tickets: number;
}

export interface TotalPrizesResponse {
  data: TotalPrizeRow[];
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
  totals: {
    total_contests: number;
    total_prize: number;
    total_prize_per_quota: number;
    awarded_tickets: number;
  };
}

export interface TotalPrizeProduct {
  contest_product_id: number;
  product_name: string;
  classification_name: string | null;
  description: string | null;
  quota_quantity: number;
  prize_per_quota: number;
  prize_total: number;
  receive_by_cashier: boolean;
}

export interface TotalPrizeDetailResponse {
  contest: TotalPrizeContest;
  products: TotalPrizeProduct[];
  summary: {
    prize_total: number;
    prize_per_quota_total: number;
    awarded_tickets: number;
  };
}

export const getTotalPrizes = (params?: TotalPrizesParams): apiResponseType => {
  const query = new URLSearchParams();

  if (params?.date_start) query.append("date_start", params.date_start);
  if (params?.date_end) query.append("date_end", params.date_end);
  params?.lottery_id?.forEach((id) => query.append("lottery_id[]", id));
  if (params?.contest_names?.trim()) query.append("contest_names", params.contest_names.trim());
  if (params?.page) query.append("page", String(params.page));
  if (params?.per_page) query.append("per_page", String(params.per_page));

  return apiAuth.get(`total-prizes?${query.toString()}`) as apiResponseType;
};

export const getTotalPrizeDetail = (contestId: number): apiResponseType =>
  apiAuth.get(`total-prizes/${contestId}`) as apiResponseType;
